import React, { forwardRef } from 'react';

const TableFooter = forwardRef(function TableFooter({ children, ...props }, ref) {
  return <tfoot ref={ref} {...props}>{children}</tfoot>;
});

TableFooter.tableSection = 'tfoot';
export default TableFooter;
